// Import only one ripple CSS at a time
// import "./ProfileRipple.css";
import "./ProfileRipplePingPong.css";
import { useState, useId } from "react";

export default function ProfileRipple() {
  const [hovered, setHovered] = useState(false);
  const clipId = useId();

  const hoverPath =
    "M 192,0 A 108 248 0 0 1 300,248 A 150 152 0 0 1 150,400 A 150 128 0 0 1 0,272 A 192 272 0 0 1 192,0 Z";

  const idlePath =
    "M 165,0 A 135 176 0 0 1 300,176 A 150 224 0 0 1 150,400 A 150 196 0 0 1 0,204 A 165 204 0 0 1 165,0 Z";

  const pathD = hovered ? hoverPath : idlePath;

  return (
    <svg
      viewBox="0 0 300 400"
      className="profile-svg"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onTouchStart={() => setHovered(true)}
      onTouchEnd={() => setHovered(false)}
    >
      <defs>
        <clipPath id={clipId}>
          <path d={pathD} className="blob-path" />
        </clipPath>
      </defs>

      {/* Ripples */}
      <g className="ripples">
        <path d={pathD} className="ripple rp1 ring1" />
        <path d={pathD} className="ripple rp1 ring2" />
        <path d={pathD} className="ripple rp1 ring3" />

        <path d={pathD} className="ripple rp2 ring1" />
        <path d={pathD} className="ripple rp2 ring2" />
        <path d={pathD} className="ripple rp2 ring3" />
      </g>

      {/* Profile image */}
      <image
        href="/images/profile-pic.jpg"
        width="300"
        height="400"
        clipPath={`url(#${clipId})`}
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  );
}
